import AsocebuWorklist from '../../features/asocebu/layouts/worklist';

// TSS vite/01 §"Pages are thin".
export default function AsocebuPage() {
    return <AsocebuWorklist />;
}
